import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoggerService} from "../../common/logger.service";
import {Constants} from "../../constants";
import {IProduct, IProductGroup, IProductResultsDetail} from "../product-models";
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {INavDisplay, ITag} from "../../cart/catalog/catalog-models";
import * as _ from "lodash";
import {CartUtil} from "../../cart/cart-util";
import {ProductService} from "../product.service";
import {ProductUtil} from '../../util/product-util';

@Component({
    selector: 'product-results-card',
    templateUrl: './product-results-card.component.html',
    styleUrls: ['./product-results-card.component.scss'],
    standalone: false
})
export class ProductResultsCardComponent extends BaseComponent implements OnInit {

    @Input() usanaId: string;
    @Input() productGroup: IProductGroup;
    @Input() productDetails: IProductResultsDetail[];
    @Input() productShareQty: number;
    quantity: number = 1;
    bodyBenefitTags: INavDisplay[];
    product: IProduct;
    showMoreDetails: boolean = false;
    @Output() readonly productAddedEvent = new EventEmitter();

    ProductUtil = ProductUtil;

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private productService: ProductService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        if (!!this.productGroup && !!this.usanaId) {
            this.initProduct();
        }
    }

    initProduct() {
        if (this.productShareQty) {
            this.quantity = this.productShareQty;
        }
        this.product = _.find(_.values(this.productGroup.products), ["usanaId", this.usanaId]);
        this.setBodyBenefits();
        this.productService.prepareProductGroup(this.productGroup, this.product.id);
    }

    setBodyBenefits() {
        this.bodyBenefitTags = _.filter(this.product.productTags, (tag: ITag) => {
            return !!tag.pdpDisplay && !!tag.parent && Constants.BODY_BENEFIT_TAG_NAME == tag.parent.name;
        }).map(tag => CartUtil.buildNavDisplay(tag));
    }

    productAddedToCart() {
        this.productAddedEvent.emit();
    }

    updateSelectedProduct(product: IProduct) {
        this.product = product;
    }

    toggleLearnMore() {
        this.showMoreDetails = !this.showMoreDetails;
    }
}
